import { useState } from "react";
import { CalendarDays, ShoppingCart, Archive } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { content, APP_PIANO_MENU, APP_PIANO_LISTA } from "@/content/fitswag";
import { PhoneFrame } from "@/components/PhoneFrame";
import Reveal from "@/components/Reveal";

const TAB_ICONS = [CalendarDays, ShoppingCart, Archive];

export default function PianoShowcase() {
  const { lang } = useLanguage();
  const t = content[lang].piano;
  const [active, setActive] = useState(0);

  return (
    <section
      id="piano"
      className="relative overflow-hidden border-t border-white/10 bg-black py-24 md:py-32"
    >
      <div className="pointer-events-none absolute left-1/4 bottom-0 h-[380px] w-[380px] rounded-full bg-brand-amber/10 blur-[130px]" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid items-center gap-14 md:grid-cols-2">
          <Reveal>
            <p className="overline text-brand-orange">{t.overline}</p>
            <h2 className="mt-3 font-display text-4xl leading-tight tracking-tighter text-white sm:text-5xl md:text-6xl">
              {t.title}
            </h2>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/70">{t.subtitle}</p>

            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="piano-goals">
              {t.goals.map((g, i) => (
                <span
                  key={i}
                  className="rounded-full border border-brand-orange/30 bg-brand-orange/10 px-4 py-1.5 text-sm font-semibold text-brand-orange"
                >
                  {g}
                </span>
              ))}
            </div>

            <div className="mt-10 space-y-3">
              {t.tabs.map((tab, i) => {
                const Icon = TAB_ICONS[i];
                const on = active === i;
                return (
                  <button
                    key={i}
                    data-testid={`piano-tab-${i}`}
                    onClick={() => setActive(i)}
                    className={`flex w-full items-start gap-4 rounded-2xl border p-5 text-left transition-colors duration-200 ${
                      on
                        ? "border-brand-orange/40 bg-white/[0.05]"
                        : "border-white/10 bg-transparent hover:bg-white/[0.03]"
                    }`}
                  >
                    <span
                      className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                        on ? "bg-brand-orange text-black" : "bg-white/5 text-brand-orange"
                      }`}
                    >
                      <Icon size={18} />
                    </span>
                    <span>
                      <span className="font-display text-lg tracking-tight text-white">
                        {tab.title}
                      </span>
                      <span className="mt-1 block text-sm leading-relaxed text-white/60">
                        {tab.desc}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative flex items-center justify-center">
              <PhoneFrame
                src={APP_PIANO_LISTA}
                alt="Lista spesa"
                size="sm"
                className="absolute -left-2 top-10 hidden rotate-[-6deg] opacity-90 sm:block lg:left-4"
              />
              <PhoneFrame src={APP_PIANO_MENU} alt="Menu 7 giorni" glow size="md" className="relative z-10" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
